import { FlaskConical, Star } from "lucide-react";
import { fmtDate } from "./api";

export const RIDE_STATUS = { scheduled: "Reserva agendada", requested: "À procura de motorista", accepted: "Motorista a caminho", arriving: "Motorista no local de recolha",
  in_progress: "Viagem em curso", completed: "Concluída", cancelled: "Cancelada" };
export const VEHICLE = { moto: "Mototáxi", carro: "Táxi" };
export const RIDE_DEMO_TEXT = "DEMONSTRAÇÃO — sem viagens, motoristas nem pagamentos reais";

export const RideDemoBanner = ({ testid = "ride-demo-banner" }) => (
  <div className="flex items-center gap-2 rounded-2xl border-2 border-dashed border-amber-400 bg-amber-50 p-3 text-sm font-bold text-amber-900" data-testid={testid}>
    <FlaskConical className="h-4 w-4 shrink-0" />{RIDE_DEMO_TEXT}
  </div>
);

export const RideStatus = ({ status }) => (
  <span className="rounded-full bg-bo-green/10 px-2.5 py-0.5 text-xs font-semibold text-bo-green" data-testid="ride-status">{RIDE_STATUS[status] || status}</span>
);

export const Stars = ({ value }) => (
  <span className="inline-flex items-center gap-0.5 text-amber-500">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-3.5 w-3.5 ${i <= value ? "fill-current" : ""}`} />)}</span>
);

export const RideHistory = ({ trip }) => (
  <ol className="flex flex-col gap-1 border-l-2 border-gray-100 pl-3 text-xs text-gray-600" data-testid="ride-history">
    {(trip.history || []).map((h, i) => <li key={i}><strong>{RIDE_STATUS[h.status] || h.status}</strong> · {fmtDate(h.at)}{h.note && ` · ${h.note}`}</li>)}
  </ol>
);
